$(document).ready(function(){
  var url_path = window.location.href;
  var order_id = url_path.split('#')[1]
  if(order_id == 'order_milestone'){
    $('#'+order_id).show();
    $('.order_milestone_btn').addClass('is-selected');
    $('.sub_sections').show();
    $('.life_time_saving_main').hide();
    $('.order_list').hide();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

   if(order_id == 'life_time_saving'){
    $('#'+order_id).show();
    $('.life_time_saving_btn').addClass('is-selected');
    $('.sub_sections').show();
    $('.order_milestone').hide();
    $('.order_list').hide();
     window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  
  $(document).on('click','.life_time_saving_btn',function(e){
    e.preventDefault();
    var id = $(this).attr('href');
    $(id).addClass('is-selected').show();
    $('.sub_sections').hide();
  });
  
  $(document).on('click','.order_milestone_btn',function(e){
    e.preventDefault();
    var id = $(this).attr('href');
    $(id).addClass('is-selected').show();
    $('.sub_sections').show();
    $('.life_time_saving_main').hide();
    $('.order_list').hide();
  });
  
});


$( document ).ready(function() {
  
 
  $('.category-slider .category-list').slick({
      dots: true,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  }); 

  $('.product-slider .product-list').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
    {
        breakpoint: 1360,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.product-slider-btm .product-list-btm').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
    {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  

  $('.customer-slider .customer-list').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 801,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });



  $('.team-slider .team-list').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  }); 

 // tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});


/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  $('.product-list').slick('refresh');
  $('.product-list-btm').slick('refresh');

});

/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");

  $('.product-list').slick('refresh');
   $('.product-list-btm').slick('refresh');
});
  

//smooth scroll down
  $(".down-scroll-link").click(function(e) {
	e.preventDefault();
	var id=$(this).attr('href');
	$('html, body').animate({
		scrollTop: $(id).offset().top-30
	}, 1000);
  });

});


// Scroll Add class
$(window).scroll(function() {    
      var scroll = $(window).scrollTop();

      if (scroll >= 500) {
              $("body").addClass("sticky-header");
      } else {
              $("body").removeClass("sticky-header");
      }
});

